var exports = {
  "button": "Button.module__button___UmNvQ1",
  "matchSkeletonHeight": "Button.module__matchSkeletonHeight___UmNvQ1",
  "small": "Button.module__small___UmNvQ1",
  "compact": "Button.module__compact___UmNvQ1",
  "superCompact": "Button.module__superCompact___UmNvQ1",
  "fitContent": "Button.module__fitContent___UmNvQ1",
  "fitContainer": "Button.module__fitContainer___UmNvQ1",
  "square": "Button.module__square___UmNvQ1",
  "primary": "Button.module__primary___UmNvQ1",
  "secondary": "Button.module__secondary___UmNvQ1",
  "danger": "Button.module__danger___UmNvQ1",
  "inverted": "Button.module__inverted___UmNvQ1",
  "invertedOutline": "Button.module__invertedOutline___UmNvQ1",
  "ghost": "Button.module__ghost___UmNvQ1",
  "recording": "Button.module__recording___UmNvQ1",
  "buttonRecordingPulse": "Button.module__buttonRecordingPulse___UmNvQ1",
  "spinner": "Button.module__spinner___UmNvQ1",
  "spinnerInner": "Button.module__spinnerInner___UmNvQ1",
  "spinnerItem": "Button.module__spinnerItem___UmNvQ1",
  "spinnerPulsingEllipsis": "Button.module__spinnerPulsingEllipsis___UmNvQ1",
  "iconWrapper": "Button.module__iconWrapper___UmNvQ1",
  "spinnerWrapper": "Button.module__spinnerWrapper___UmNvQ1",
  "hidden": "Button.module__hidden___UmNvQ1",
  "grid": "Button.module__grid___UmNvQ1",
};

__webpack_require__.r(module.exports = exports);
